import { BASEAPIGESTTORAUTH } from '../api/gesttor'
import { buscarOrganizacoesUsuario, loginPayload, recuperarSenhaPayload, novaSenhaCadastrarPayload } from "../../interfaces/auth"

export function buscarOrganizacoes (payload: buscarOrganizacoesUsuario) {
    return BASEAPIGESTTORAUTH.post('/auth/organizacoes', payload)
}

export function auth (payload: loginPayload) {
    return BASEAPIGESTTORAUTH.post ('/auth', payload)
}

export function recuperarSenha (payload: recuperarSenhaPayload) {
    return BASEAPIGESTTORAUTH.post('/recuperarsenha', payload)
}

export function novaSenha (payload: novaSenhaCadastrarPayload) {
    return BASEAPIGESTTORAUTH.post ('/novasenha', payload)
}

